import { ActionTree } from 'vuex';
import { RootState, UiState } from '@/types';
import * as types from './types';
import { FOOTER_NEWS_CONFIG } from '@/sensefly.config';
import axios from 'axios';

const actions: ActionTree<UiState, RootState> = {
  toggleLegalMessage({ commit }, shouldShow) {
    commit(types.TOGGLE_LEGAL_MESSAGE, shouldShow);
  },
  toggleMobileMenu({ commit }, shouldShow) {
    commit(types.TOGGLE_MOBILE_MENU, shouldShow);
  },
  toggleNewProductModal({ commit }, shouldShow) {
    commit(types.TOGGLE_NEW_PRODUCT_MODAL, shouldShow);
  },
  async fetchNewsBanner({ commit }) {
    await axios.get(FOOTER_NEWS_CONFIG)
        .then(({ data }) => {
          const shouldShowBanner = doesBannerImageExist(data.imageUrl);
          if (shouldShowBanner) {
            commit(types.SET_NEWS_BANNER, data);
          }
        });
  },
};

function doesBannerImageExist(imageUrl: string) {
  const img = new Image();
  img.src = imageUrl || '';

  return new Promise((resolve) => {
    img.onerror = () => resolve(false);
    img.onload = () => resolve(true);
  });
}

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/ui/actions.ts